import { render, staticRenderFns } from "./SelfBiographyEditorial.vue?vue&type=template&id=99cbade8&scoped=true"
import script from "./SelfBiographyEditorial.vue?vue&type=script&lang=js"
export * from "./SelfBiographyEditorial.vue?vue&type=script&lang=js"
import style0 from "./SelfBiographyEditorial.vue?vue&type=style&index=0&id=99cbade8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cbade8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
